<template>
	<div
		class="case-study-overview-container"
		id="case-studies-overview-container"
	>
		<div class="title" id="case-studies-overview">
			<div class="info">Case Studies</div>
			<div class="posts">
				<div
					class="card"
					v-for="(item, index) in caseStudies"
					:key="index"
				>
					<div class="post-title">
						{{ item.title }}
					</div>
					<div class="post-subtitle">
						{{ item.subtitle }}
					</div>
					<div class="post-cta">
						<div>&nbsp;</div>
						<a target="_blank" :href="item.link">
							<button
								class="filled-btn"
								@click="openDialog(item)"
							>
								Read more...
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>
		<transition name="modal" mode="out-in">
			<modal
				:show="isOpen"
				@close="isOpen = false"
				:title="selCaseStudy && selCaseStudy.title"
			>
				<div
					v-if="selCaseStudy && selCaseStudy.case_study"
					class="cs_lists"
				>
					<div
						v-if="selCaseStudy.case_study.challenge"
						class="cs_block"
					>
						<div class="title">Challenge:</div>
						<div v-html="selCaseStudy.case_study.challenge" class="content"></div>
					</div>
					<div
						v-if="selCaseStudy.case_study.solution"
						class="cs_block"
					>
						<div class="title">Solution:</div>
						<div v-html="selCaseStudy.case_study.solution" class="content"></div>
					</div>
					<div
						v-if="selCaseStudy.case_study.outcome"
						class="cs_block"
					>
						<div class="title">Outcome:</div>
						<div v-html="selCaseStudy.case_study.outcome" class="content"></div>
					</div>
				</div>
			</modal>
		</transition>
	</div>
</template>
<script>
import Modal from "./Modal.vue";
export default {
	data() {
		return {
			isOpen: false,
			caseStudies: [
				// {
				// 	title: "TollFree Call Peering",
				// 	subtitle: "A peer to peer calling system",
				// 	case_study: {
				// 		challenge: "The TollFree call peering platform was a new product and concept had no competition in the market when it was introduced. The features and customer experience had to be thought through from scratch. In addition from the inception the concept was fairly complex. The platform had 2 conduits the web interface for customers to set things up and get billing information, the second conduit was SIP signals. Also, at the backend the platform had to aggregate data from different sources that was constantly updated through streaming and information had to be deduced and kept up to date.  Also this was a product in the telecom world which means the performance had to kept in mind since the inception. The maximum response time to any incoming SIP signals was a few milliseconds tops.",
				// 		solution: "Based on the requirements of the platform we identified multiple components on the platform and started thinking about the architecture from the beginning. We chose Service Oriented Architecture(SOA) from the beginning and made sure each component is as self contained as possible so that the services don’t get too chatty. Microservices, Containerization, Orchestration weren’t that popular in 2015. We focused on the performance of each of the service from the beginning.<br /><br />There were indeed a trade offs where things took longer to deliver and we set the expectations accordingly. The nature of the platform was such that we had to build the whole platform first where the calls could be peered through so we could not release the product iteratively. To cover this we wrote automates tests, ran simulations and tested components with available tools as much as possible making each service as performant and we constantly revisited our architecture and current progress to make sure we are not over engineering the solution to keep the costs and time in check.<br /><br />Once all the components of the platform were built and managed services were integrated. The parent company was able to direct some of its traffic through the platform and the immediate realization that we will need to scale some services of the  application. We started looking at the options of how we can horizontally scale the application. This was specifically necessary during the early morning call traffic of the different US timezones. After working in telecom for a number of years one thing we always remember is, the devised solution should always be highly available its bad for business if things go down/crash.<br /><br />We added horizontal scaling and made the communication between the components that needed to scale asynchronous and made sure the platform was highly available and as more and more customers big and small started to become of the platform the scaling mechanism was a success. The platform was able to connect hundreds of thousands of calls through its network and call traffic handle spikes and bill them as well ;)",
				// 		outcome: "The Tollfree call peering system caused a disruption on how TollFree calls were connected in the US. The RespOrgs on the originating and terminating could both have profits by participating on the platform. The platform won multiple awards from different orgninzations. There are fairly big and small customers using the platform today and have good things to say about it. We still treat this product as our baby if work comes through and take a lot of pride in saying that we built it.",
				// 	},
				// },
				{
					title: "Call Records Archiver",
					subtitle: "Keep billions of CDRs online",
					case_study: {
						challenge: "The client we had was doing a little over 1 billion calls every month and this produced roughly 15 Gi - 20 Gi worth of CDR records everyday. The other challenge the CDRs getting generated were getting at different hosts and were in different formats. Plus three different protocols had to be supported for downloading depending on the SBC and Switches. The existing system that was implemented was not able to keep up with downloading, processing and storing of the CDRs. The billing system didn’t have all CDRs to build the CDRs were not getting processed properly as well. The existing was doing everything serially and posing to be a challenge.",
						solution: "We walked in to provide a solution and the first thing did was took a step back looked at the challenge and came up with a architecture using the concept of microservices. We then identified the 3 modules that for making CDRs accessible. The first would be downloader, the second would be parser and the third would be uploader of parsed data.<br />Then based on the volume of the data and functionality of the modules we chose to implement the solution in Go programming language.<br /><br />Downloader: The downloader had a relatively simple functionality of downloading the CDR files but it needed to support different protocols of ftp, sftp and cloud-object storage so we create 3 different services based on the protocol<br />Parser: Each CDR was generated in a different format and had different fields for example some files were tab separated, some were comma separated and some were fixed width depending on the SBC/switch like sansay, sonus, verizon, meta and others. So we decided to create individual parser service for 14 different sources resulting in 14 individual parsers which will parse the data and create a common interface for the CDR and keep the oiriginal data field.<br />Uploader: With thousands files downloaded and millions CDRs parsed we needed to upload the data to a datastore one instance was not enough so we ran multiple replicas to keep up with parsed getting generated. We also added horizontal scaling with uploaders in case there is too much data getting written on the mount.<br />To communicate between the different services we used event driven architecture to notify each service for it to perform its task.<br />We then built an API for other services like billing to fetch the CDR data and interface for team members to lookup the data.<br />We released services iteratively since as we planned, built and shipped. We implemented CI/CD using Drone and orchestrated the services using kubernetes with centralized logging using loki, metrics using prometheus, and istio gateway.<br /><br />We basically devised the architecture, programming language, deployment based on what suited for the application, team knowledge and skillset we had and made the initiative a successful implementation of uploading over billion call records every month and keep them accessible.",
						outcome: "This initiative had a significant impact on the orgnizations operations. When billing cycles run all the CDR data becomes available and re-runs are not needed because of issues.<br />The datastore keeps billions and billions of records online and makes them searchable in realtime. This helps the telecom operations and finance teams could access the CDR data for audit, consolidation and conflict resolution purposes.<br />The system has been performing well since the last 2 years and more and more data is getting absorbed every day and being made available for lookup.",
					},
				},
			],
			selCaseStudy: null,
		};
	},
	components: {
		Modal,
	},
	methods: {
		closeDailog() {
			this.isOpen = false;
		},
		openDialog(data) {
			this.selCaseStudy = data;
			this.isOpen = true;
		},
	},
};
</script>
<style lang="less" scoped>
.case-study-overview-container {
	color: #ffffff;
	.title {
		max-width: 1280px;
		margin: 0 auto;
		.info {
			font-size: 32px;
			text-align: center;
			padding: 0px 20px;
			margin: 30px 0px;
			font-weight: bold;
		}
		.posts {
			display: flex;
			justify-content: space-between;
			.card {
				display: flex;
				background: #ffffff;
				border-radius: 12px;
				margin: 0 0 30px 0;
				padding: 30px;
				flex-direction: column;
				width: 500px;
				box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
				text-align: left;
				.post-title {
					font-size: 24px;
					font-weight: bold;
				}
				.post-subtitle {
					font-size: 16px;
				}
				.post-cta {
					display: flex;
					justify-content: space-between;
					align-items: center;
					button {
						background: linear-gradient(
							107.65deg,
							#17c969 17.53%,
							#005dbb 94.64%
						);
						color: #ffffff;
						border: none;
						padding: 10px 20px;
						border-radius: 5px;
						font-size: 16px;
						font-weight: bold;
						cursor: pointer;
					}
				}
			}
		}
	}
}
@media screen and (max-width: 768px) {
	.careers-container {
		.careers-bg {
			padding: 50px 20px;
		}
		.positions {
			.posts {
				flex-direction: column;
				.card {
					width: initial;
					margin: 0 10px 30px 10px;
				}
			}
		}
	}
}
.cs_lists {
	.cs_block {
    padding: 10px 0;
		.title {
			font-size: 14px;
			font-weight: bold;
		}
        .content{
            font-size: 12px;
        }
	}
}
</style>
